/* 90'S HOME v2 — hiệu ứng cuộn (theo hàm tick() trong file thiết kế).
   data-reveal=""        : trượt lên 72px + phóng 0.88→1 (desktop 0.9) + hiện dần
   data-reveal="zoom"    : ảnh banner phóng tới 1.22 (desktop 1.18)
   data-reveal="slide"   : hàng vuốt ngang trượt từ phải 140px
   data-reveal="sun|moon": dải hoàng hôn
   Hậu tố "@m" / "@d": chỉ chạy trên mobile / desktop (≥990px).
   data-lag="n"          : cột thứ 2/3 trễ hơn một chút (data-lag-m: riêng cho mobile).
   [data-count]          : số đếm lên khi vào màn hình. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesk = window.matchMedia('(min-width: 990px)');
  var armed = false, raf = 0, to = 0;
  var header = document.querySelector('.section-header');

  function clamp(v) { return Math.max(0, Math.min(1, v)); }
  function ease(p) { return 1 - Math.pow(1 - p, 3); }

  function countUp(el) {
    el.dataset.done = '1';
    var raw = el.textContent.trim();
    var m = raw.match(/^([\d.]+)(.*)$/);
    if (!m) return;
    var to = parseInt(m[1].replace(/\./g, ''), 10), rest = m[2];
    if (reduce || !(to >= 10)) return;
    var t0 = performance.now(), d = 1200;
    function step(t) {
      var k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(to * e).toLocaleString('vi-VN') + rest;
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function clear(el) { el.style.opacity = ''; el.style.translate = ''; el.style.scale = ''; el.style.filter = ''; }

  function tick() {
    var vh = window.innerHeight, desk = mqDesk.matches;
    if (header) header.classList.toggle('v2-scrolled', window.scrollY > 4);

    document.querySelectorAll('[data-count]:not([data-done])').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.9) countUp(el);
    });

    if (reduce || !armed || document.hidden) return;

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      var t = el.getAttribute('data-reveal') || 'rise';
      var only = t.split('@')[1];
      t = t.split('@')[0] || 'rise';
      if ((only === 'm' && desk) || (only === 'd' && !desk)) { clear(el); return; }
      var r = el.getBoundingClientRect();

      if (t === 'zoom') {
        var pz = clamp(((desk ? 120 : 80) - r.top) / r.height);
        el.style.scale = String(1 + (desk ? 0.18 : 0.22) * pz);
        el.style.filter = desk ? '' : 'brightness(' + (1 - 0.35 * pz) + ')';
        return;
      }
      if (t === 'sun' || t === 'moon') {
        var b = el.parentElement.getBoundingClientRect(), ps = clamp((vh - b.top) / (vh * 0.85));
        if (t === 'sun') {
          el.style.translate = '0 ' + (ps * (desk ? 260 : 230)) + 'px';
          el.style.scale = String(1 - 0.35 * ps);
          el.style.opacity = String(1 - 0.6 * ps);
        } else {
          el.style.opacity = String(clamp((ps - 0.45) / 0.4));
          el.style.translate = '0 ' + ((1 - ps) * 20) + 'px';
        }
        return;
      }
      var n = +((!desk && el.dataset.lagM != null ? el.dataset.lagM : el.dataset.lag) || 0);
      var lag = desk ? (n % 3) * 80 : (n % 2) * 100;
      var p = r.bottom < 0 ? 1 : ease(clamp((vh - r.top - lag) / (vh * (desk ? 0.4 : 0.45))));
      el.style.opacity = String(p);
      if (t === 'slide') {
        el.style.translate = ((1 - p) * 140) + 'px 0';
      } else {
        el.style.translate = '0 ' + ((1 - p) * 72) + 'px';
        el.style.scale = String((desk ? 0.9 : 0.88) + (desk ? 0.1 : 0.12) * p);
      }
    });
  }

  function run() { cancelAnimationFrame(raf); clearTimeout(to); raf = 0; tick(); }
  function onScroll() {
    armed = true;
    if (raf) return;
    raf = requestAnimationFrame(run);
    to = setTimeout(run, 120);
  }

  /* Chấm viên thuốc cho hàng vuốt ngang */
  function initDots() {
    document.querySelectorAll('[data-v2-dots]').forEach(function (dots) {
      var track = document.getElementById(dots.getAttribute('data-v2-dots'));
      if (!track || dots.dataset.ready) return;
      dots.dataset.ready = '1';
      var items = track.children, n = items.length;
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        var idx = max > 0 ? Math.round((track.scrollLeft / max) * (n - 1)) : 0;
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === idx); });
      }
      track.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  function init() {
    initDots();
    tick();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Theme Editor: khối vừa thêm/sửa */
  document.addEventListener('shopify:section:load', function () { initDots(); tick(); });
})();
